import styles from "./Button.module.scss";

const Button = ({
  type = "button",
  text,
  children,
  onClick,
  styleType,
  disabled,
}) => {
  // Bootstrapのスタイル
  let style = "";
  if (styleType === "logout")
    style = "btn btn-outline-primary " + styles.btn__logout;
  if (styleType === "search") style = "btn btn-primary " + styles.btn;
  if (styleType === "new") style = "btn btn-primary " + styles.btn;
  if (styleType === "login") style = "btn btn-primary " + styles.btn;
  if (styleType === "register") style = "btn btn-success " + styles.btn;
  if (styleType === "back") style = "btn btn-primary " + styles.btn__back;
  if (styleType === "tab") style = "btn btn-primary " + styles.btn__tab;
  if (styleType === "tab_active")
    style = "btn btn-primary " + styles.btn__tab__active;
  if (styleType === "upload") style = "btn " + styles.btn__upload;

  return (
    <button
      className={`${style}`}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {children}
    </button>
  );
};
export default Button;
